<template>
  <b-modal
    id="changepassword-modal"
    ref="modal"
    title="Zmiana hasła"
    @hidden="onClose"
  >
    <p>Zmień bieżące hasło do konta głównego:</p>
    <ValidationObserver
      ref="formValidation"
      tag="form"
      @submit.prevent="onSubmit"
      id="changepassowrdForm"
    >
      <div class="form-group row">
        <label for="currentPassword" class="col-lg-4 col-form-label text-lg-right">Aktualne hasło:</label>
        <div class="col-lg-8">
          <ValidationProvider
            name="oldpassword"
            rules="required"
            v-slot="validationContext"
            mode="lazy"
          >
            <b-form-input
              id="currentPassword"
              v-model="form.oldpassword"
              type="password"
              :state="getValidationState(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </div>
      </div>
      <div class="form-group row">
        <label for="password" class="col-lg-4 col-form-label text-lg-right">Nowe hasło:</label>
        <div class="col-lg-8">
          <ValidationProvider
            name="password"
            rules="required|min:8|password:@password_confirmation"
            v-slot="validationContext"
            mode="lazy"
          >
            <b-form-input
              id="password"
              v-model="form.password"
              type="password"
              :state="getValidationState(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </div>
      </div>
      <div class="form-group row">
        <label for="password_confirmation" class="col-lg-4 col-form-label text-lg-right">Potwierdź hasło:</label>
        <div class="col-lg-8">
          <ValidationProvider
            name="password_confirmation"
            rules="required|min:8"
            v-slot="validationContext"
            mode="lazy"
          >
            <b-form-input
              id="password_confirmation"
              v-model="form.password_confirmation"
              type="password"
              :state="getValidationState(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </div>
      </div>
    </ValidationObserver>
    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="primary" type="submit" form="changepassowrdForm">Zapisz</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
import ApiService from "@/services/api.service";

export default {
  name: "ModalChangePassword",
  data() {
    return {
      form: {
        oldpassword: "",
        password: "",
        password_confirmation: ""
      }
    };
  },
  methods: {
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onClose() {
      this.form.oldpassword = "";
      this.form.password = "";
      this.form.password_confirmation = "";
    },
    onSubmit() {
      this.$refs.formValidation.validate().then(success => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        ApiService.put("/user/password", this.form)
          .then(() => {
            this.$store.commit("lastapimessage/push", {
              message: "password has been changed"
            });
            this.$nextTick(() => {
              this.$bvModal.hide("changepassword-modal");
            });
          })
          .catch(error => {
            this.$refs.formValidation.setErrors(error.response.data.fields);
          });
      });
    }
  }
};
</script>